

























import { formatCurrency } from "@/lib/utility/currency-helper";
import { simpleDoubleDigitDate } from "@/lib/utility/date-helper";
import { RefTypeMap } from "@/store/modules/refs.store";
import { Component, Prop } from "vue-property-decorator";
import BaseRef from "./BaseRef.vue";
import { IRefDetail } from "./RefsList.vue";
import Tooltip from "./tooltip.vue";
import { IVideo } from "@/models/video.entity";

@Component({
  components: { Tooltip },
  filters: { simpleDoubleDigitDate }
})
export default class RefsVideo extends BaseRef<IVideo> implements IRefDetail<IVideo> {
  readonly RefsTypeMap = RefTypeMap;
  readonly formatCurrency = formatCurrency;

  @Prop()
  item!: IVideo;

  @Prop({ default: false })
  small!: boolean;

  @Prop({ default: false })
  confirmable!: boolean;

  goToDetail() {
    this.$router.push({
      name: "VideoDetailView",
      params: {
        partnerId: this.item.partnerId,
        videoId: this.item.id
      }
    });
  }

  get hasOpenDetailListener() {
    return Boolean(this.$listeners && this.$listeners.openDetail);
  }

  get hasClickListener() {
    return Boolean(this.$listeners && this.$listeners.click);
  }
}
